import { render, staticRenderFns } from "./PaidRegistration.vue?vue&type=template&id=07ec1b8f&scoped=true&"
import script from "./PaidRegistration.vue?vue&type=script&lang=js&"
export * from "./PaidRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PaidRegistration.vue?vue&type=style&index=0&id=07ec1b8f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ec1b8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
